// const UpdateLabelFile = () => {
//   const fileInputs = document.querySelectorAll(".form-field__input[type='file']");

//   fileInputs.forEach((fileInput) => {
//     const label = document.querySelector(`.custom-file-upload[for='${fileInput.id}']`);
//     const labelText = label.querySelector(".custom-file-upload-text");

//     fileInput.addEventListener('change', () => {
//       if (fileInput.files.length > 0) {
//         labelText.textContent = fileInput.files[0].name;
//         labelText.style.color = "#f8f8f8";
//       } else {
//         labelText.textContent = 'Upload your resume';
//         labelText.style.color = "$grey-500";
//       }
//     });
//   });
// }

// export default UpdateLabelFile;

const UpdateLabelFile = () => {
  const forms = [...document.querySelectorAll(".wpcf7-form")];

  if (forms.length > 0) {
    forms.forEach((form) => {
      const fileInputs = form.querySelectorAll(".form-field__input[type='file']");

      fileInputs.forEach((fileInput) => {
        const label = form.querySelector(`.custom-file-upload[for='${fileInput.id}']`);
        const labelText = label.querySelector(".custom-file-upload-text");

        fileInput.addEventListener('change', () => {
          if (fileInput.files.length > 0) {
            labelText.textContent = fileInput.files[0].name;
            labelText.style.color = "#f8f8f8";
          } else {
            labelText.textContent = 'Upload your resume';
            labelText.style.color = "#808080";
          }
        });
      });

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === "class" && form.classList.contains("sent")) {
            fileInputs.forEach(function (fileInput) {
              fileInput.value = "";
              const label = document.querySelector(`.custom-file-upload[for='${fileInput.id}']`);
              const labelText = label.querySelector(".custom-file-upload-text");
              labelText.textContent = 'Upload your resume';
              labelText.style.color = "#808080";
            });
          }
        });
      });

      observer.observe(form, { attributes: true });
    })
  }
};

export default UpdateLabelFile;